import { render, staticRenderFns } from "./IndexDynamicModules.vue?vue&type=template&id=4d09440b&"
import script from "./IndexDynamicModules.vue?vue&type=script&lang=ts&"
export * from "./IndexDynamicModules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports